module.exports = __webpack_public_path__ + "media/images/HeartGray-ab62f1eb.svg";